import {createStore, split} from '@effector/effector'
import {runRuntime} from '../workingSet'

export const isPlay = createStore(true).reset(runRuntime)
export const {play, __: pause} = split(isPlay, {
  play: Boolean
})
